"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundaryWrapper = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var emotion_1 = require("emotion");
var sentrySdk_1 = require("../../sdks/sentry/sentrySdk");
var SentrySeverity_1 = require("../../sdks/sentry/SentrySeverity");
var appStyleClasses_1 = require("../../styles/appStyleClasses");
var AppUpdatedMain_1 = require("../main/AppUpdatedMain");
var appStylesBase_1 = require("../../styles/appStylesBase");
var ErrorBoundaryWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(ErrorBoundaryWrapper, _super);
    function ErrorBoundaryWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundaryWrapper.getDerivedStateFromError = function (error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: (error === null || error === void 0 ? void 0 : error.name) === 'ChunkLoadError' ? 'ChunkLoadError' : true,
        };
    };
    ErrorBoundaryWrapper.prototype.componentDidCatch = function (error, _errorInfo) {
        var errorString = typeof error === 'string' ? error : error.message || 'no error message';
        (0, sentrySdk_1.sentrySdk)().captureMessage("getDerivedStateFromError: ".concat(errorString), SentrySeverity_1.SentrySeverity.Critical);
    };
    ErrorBoundaryWrapper.prototype.render = function () {
        if (this.state.hasError) {
            if (this.state.hasError === 'ChunkLoadError') {
                return react_1.default.createElement(AppUpdatedMain_1.AppUpdatedMain, null);
            }
            return (react_1.default.createElement("div", { className: (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n            text-align: center;\n          "], ["\n            text-align: center;\n          "]))) },
                react_1.default.createElement("h2", { className: (0, emotion_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n              margin: 16px;\n              line-height: ", ";\n            "], ["\n              margin: 16px;\n              line-height: ", ";\n            "])), (0, appStylesBase_1.appStylesBase)().lineHeight.small) }, "Oops! Something went wrong. Try reloading or check back later."),
                react_1.default.createElement("button", { type: "button", className: appStyleClasses_1.appStyleClasses.actionButtonStyles(), title: "Reload", onClick: function () {
                        window.location.reload();
                    } }, "Reload")));
        }
        else {
            return this.props.children;
        }
    };
    return ErrorBoundaryWrapper;
}(react_1.default.Component));
exports.ErrorBoundaryWrapper = ErrorBoundaryWrapper;
var templateObject_1, templateObject_2;
